import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import precisiontool from '../images/high-precision-tools-sies.png';
import fixtures from '../images/custom-jigs-fixtures.png';
import carbide from '../images/mold-parts-carbide-tooling.png';
import modification from '../images/rework-modification-of-machine-parts.png';
import fabrication from '../images/fabrication-consultation-image.png';




const App = () => {
    return (
        <div className="relative w-full overflow-hidden">
            <div className="pl-6 lg:pl-10 pr-0">
                <Swiper
                    spaceBetween={30}
                    freeMode={true}
                    pagination={{ clickable: true }}
                    breakpoints={{
                        0: { slidesPerView: 1.2 },
                        640: { slidesPerView: 2 },
                        1024: { slidesPerView: 2.5 },
                    }}
                    modules={[FreeMode]}
                    className="mt-6 lg:mt-10"
                >
                    <SwiperSlide>
                        <div className='group transition-all duration-300 cursor-pointer'>
                            <div className="overflow-hidden rounded-xl">
                                <img
                                    src={precisiontool}
                                    alt=""
                                    className="max-h-[268px] w-full rounded-xl transform transition-transform duration-500 group-hover:scale-105"
                                    loading="lazy"
                                />
                            </div>
                            <div>
                                <div className='flex gap-4 mt-3'>
                                    <span className='tracking-tight text-gray-800 text-sm sm:text-base  text-base font-medium'>Elliot Hesp</span>
                                    <span className='tracking-tight text-gray-800 text-sm sm:text-base font-medium'>Feb 5, 2025</span>
                                </div>
                                <h3 className='text-black sm:text-xl text-lg font-semibold flex items-center leading-[inherit]'>
                                    High-Precision Tools & Dies 
                                </h3>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className='group transition-all duration-300 cursor-pointer'>
                            <div className="overflow-hidden rounded-xl">
                                <img
                                    src={fixtures}
                                    alt=""
                                    className="max-h-[268px] w-full rounded-xl transform transition-transform duration-500 group-hover:scale-105"
                                    loading="lazy"
                                />
                            </div>
                            <div>
                                <div className='flex gap-4 mt-3'>
                                    <span className='tracking-tight text-gray-800 text-sm sm:text-base  text-base font-medium'>Elliot Hesp</span>
                                    <span className='tracking-tight text-gray-800 text-sm sm:text-base font-medium'>Feb 5, 2025</span>
                                </div>
                                <h3 className='text-black sm:text-xl text-lg font-semibold flex items-center leading-[inherit]'>
                                   Custom Jigs & Fixtures 
                                </h3>
                            </div>
                        </div>

                    </SwiperSlide>

                    <SwiperSlide>
                        <div className='group transition-all duration-300 cursor-pointer'>
                            <div className="overflow-hidden rounded-xl">
                                <img
                                    src={carbide}
                                    alt=""
                                    className="max-h-[268px] w-full rounded-xl transform transition-transform duration-500 group-hover:scale-105"
                                    loading="lazy"
                                />
                            </div>
                            <div>
                                <div className='flex gap-4 mt-3'>
                                    <span className='tracking-tight text-gray-800 text-sm sm:text-base  text-base font-medium'>Elliot Hesp</span>
                                    <span className='tracking-tight text-gray-800 text-sm sm:text-base font-medium'>Feb 5, 2025</span>
                                </div>
                                <h3 className='text-black sm:text-xl text-lg font-semibold flex items-center leading-[inherit]'>
                                   Mold Parts & Carbide Tooling 
                                </h3>
                            </div>
                        </div>

                    </SwiperSlide>

                       <SwiperSlide>
                        <div className='group transition-all duration-300 cursor-pointer'>
                            <div className="overflow-hidden rounded-xl">
                                <img
                                    src={modification}
                                    alt=""
                                    className="max-h-[268px] w-full rounded-xl transform transition-transform duration-500 group-hover:scale-105"
                                    loading="lazy"
                                />
                            </div>
                            <div>
                                <div className='flex gap-4 mt-3'>
                                    <span className='tracking-tight text-gray-800 text-sm sm:text-base  text-base font-medium'>Elliot Hesp</span>
                                    <span className='tracking-tight text-gray-800 text-sm sm:text-base font-medium'>Feb 5, 2025</span>
                                </div>
                                <h3 className='text-black sm:text-xl text-lg font-semibold flex items-center leading-[inherit]'>
                                Rework & Modification of Machine Parts 
                                </h3>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className='group transition-all duration-300 cursor-pointer'>
                            <div className="overflow-hidden rounded-xl">
                                <img
                                    src={fabrication}
                                    alt=""
                                    className="max-h-[268px] w-full rounded-xl transform transition-transform duration-500 group-hover:scale-105"
                                    loading="lazy"
                                />
                            </div>
                            <div>
                                <div className='flex gap-4 mt-3'>
                                    <span className='tracking-tight text-gray-800 text-sm sm:text-base  text-base font-medium'>Elliot Hesp</span>
                                    <span className='tracking-tight text-gray-800 text-sm sm:text-base font-medium'>Feb 5, 2025</span>
                                </div>
                                <h3 className='text-black sm:text-xl text-lg font-semibold flex items-center leading-[inherit]'>
                                 CAD Design, Fabrication & Consultation 
                                </h3>
                            </div>
                        </div>

                    </SwiperSlide>

                </Swiper>
            </div>
        </div>
    );
};

export default App;
